import React from "react";
import {Button} from "react-bootstrap";
import Stack from "@mui/material/Stack";
import BasicActionButton from "../../../v3/common/BasicActionButton";
import styles from "./Utilities/Styles.module.css"

const MetricsDetailFilter = ({ filterDropDown, onFilterFormSubmit, handleFilterReset }) => {

    const renderFilterButtons = () => {
        return (
            <div className={styles.filterDropdownButton}>
                <div className="reset-button">
                    <Button onClick={handleFilterReset} className="resetFilters">Reset filters</Button>
                </div>
                <div className="filter-submit-buttons">
                    <BasicActionButton label={'Apply filters'} action={onFilterFormSubmit} sx={{width: 'fit-content'}}/>
                </div>
            </div>
        )
    }

    return (
        <Stack spacing={2} className="response-filter-box">
            <span className="filter-by fustat-semi-bold" >Filter by</span>
            <div className={styles.filterDropdown}>
                {filterDropDown}
            </div>
            <hr/>
           {renderFilterButtons()}
        </Stack>
    )
}

export {MetricsDetailFilter}